<div [formGroup]="parentForm">
  <div fxLayout="row wrap" fxLayoutGap="20px grid" [formGroupName]="authControlKey">
    <div fxFlex="100">
      <mat-card class="u-margin-bottom-15">
        <mat-card-header>
          <mat-card-title
            >{{ "module-assignment.ebasket_settings.sales_export.authentication_details" | translate
            }}
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div fxFlex="100">
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    [required]="isRequired('folderName')"
                    formControlName="ftpUrl"
                    id="ftpUrl"
                    matInput
                    [placeholder]="
                  'module-assignment.ebasket_settings.sales_export.ftp_url' |
                  translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    [required]="isRequired('folderName')"
                    formControlName="folderName"
                    id="folderName"
                    matInput
                    [placeholder]="
                  'module-assignment.ebasket_settings.sales_export.folderName' |
                  translate"
                  />
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row wrap" fxLayoutGap="20px grid">
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    [required]="isRequired('folderName')"
                    formControlName="userName"
                    id="userName"
                    matInput
                    [placeholder]="
                  'module-assignment.ebasket_settings.sales_export.username' |
                  translate"
                  />
                </mat-form-field>
              </div>
              <div fxFlex="50">
                <mat-form-field class="mat-block">
                  <input
                    [required]="isRequired('folderName')"
                    formControlName="password"
                    id="password"
                    matInput
                    [placeholder]="
                  'module-assignment.ebasket_settings.sales_export.password' |
                  translate"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
